import { useIndicadores } from "@/hooks/use-indicadores";
import { formatMonto } from "@/lib/monto";
import { Skeleton } from "@/components/ui/skeleton";

/** UF y UTM del día: unidades oficiales usadas por Mercado Público. */
export function IndicadoresBadge() {
  const { indicadores, loading, esFallback } = useIndicadores();

  if (loading) {
    return <Skeleton className="hidden md:block h-7 w-40 rounded-md" data-testid="indicadores-skeleton" />;
  }

  const fechaLabel = esFallback
    ? "Valores de respaldo (no se pudo consultar el indicador del día)"
    : `Valores al ${indicadores.fecha}`;

  const fuenteLabel = {
    bcentral: "Banco Central de Chile (oficial)",
    mindicador: "mindicador.cl",
    persistido: "Último valor conocido",
    fallback: "Valores de respaldo",
  }[indicadores.fuente ?? "mindicador"];

  return (
    <div
      className="hidden md:flex items-center gap-2 rounded-md border border-border bg-surface px-2.5 py-1 text-xs"
      title={`${fechaLabel} · Fuente: ${fuenteLabel}`}
      aria-label="Indicadores UF y UTM del día"
    >
      <span className="inline-flex items-center gap-1">
        <span className="font-medium text-muted-foreground">UF</span>
        <span className="font-mono text-foreground">${formatMonto(indicadores.uf, "UF")}</span>
      </span>
      <span className="hidden lg:inline text-border">|</span>
      <span className="hidden lg:inline-flex items-center gap-1">
        <span className="font-medium text-muted-foreground">UTM</span>
        <span className="font-mono text-foreground">${formatMonto(indicadores.utm, "CLP")}</span>
      </span>
      {esFallback && <span className="text-warning" title={fechaLabel}>·</span>}
    </div>
  );
}
